export default {"src":"/_next/static/media/ellipse4.0f33a12f.svg","height":176,"width":176,"blurWidth":0,"blurHeight":0};